import { render, staticRenderFns } from "./home.vue?vue&type=template&id=6106b913&scoped=true&"
import script from "./home.ts?vue&type=script&lang=ts&"
export * from "./home.ts?vue&type=script&lang=ts&"
import style0 from "./home.scss?vue&type=style&index=0&id=6106b913&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106b913",
  null
  
)

export default component.exports